var CCF;

  (function(url, position, callback){
        url = url || 'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js';
        position = position || 0;

        if (!window.jQuery) {
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement("script");
            script.src = url;
            script.type = 'text/javascript';
            head.appendChild(script);
            head.insertBefore(script,head.childNodes[position]);

            script.onload = function(){
                if(typeof callback == 'function') {
                    callback(jQuery);
                }
            };
        } else {
            if(typeof callback == 'function') {
                callback(jQuery);
            }
        }
    }('https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js', 5, function($){

        CCF = jQuery.noConflict();
        init_ccf();

    }));

function init_ccf(){
  //console.log("CCF started");

  CCF(".CCF_fields").hide();

  // check if app is activate
  check_app_activated();
}

function validate(target, message) {
  alert(message);
  CCF(target).focus().css('outline', '1px solid #FF0000');
  return false;
}

function check_app_activated() {

    var request = CCF.ajax({
      url: "/apps/CCF",
      method: "POST",
      data: {action: "check_store"},
      dataType: "json",
      crossDomain: true
    });

    request.done(function( data ) {
      console.log(data);

      if(data.is_valid_store){
        CCF(".CCF_fields").show();

        set_cart_options(data);
      }
    })

}

function set_cart_options(data) {

  var total_price_selector = ".totals .totals__total-value, .totals .totals__subtotal-value, .money bacurr-money buckscc-money";
  var store_currency = CCF('.store_currency').text();
  var cart_total = CCF('.cart-total').text();

  // Returns the surcharge (as a fixed amount) contributed by one field
function get_extra_for($el) {
  var cost = 0;
  var type = "fixed";

  if ($el.is(':checkbox')) {

    if (!$el.is(':checked')) return 0;

    cost = Number($el.data("additional")) || 0;
    type = $el.data("additional-type") || "fixed";

  } else if ($el.is('select')) {

    // Custom logic for Residence dropdown
    if (
      $el.attr('name') === 'attributes[Shipping to a Business or Residence?]'
    ) {
      if ($el.val() === 'Residence') {
        return 6;
      }
      return 0;
    }

    var $opt = $el.find('option:selected');
    cost = Number($opt.data("additional")) || 0;
    type = $opt.data("additional-type") || $el.data("additional-type") || "fixed";

  } else {
    return 0;
  }

  if (cost <= 0) return 0;

  if (type == "fixed") {
    return cost;
  } else {
    var ct = Number(cart_total) / 100;
    return (ct / 100) * cost;
  }
}

  // Recalculate the whole surcharge from scratch
  function calc_total_extra() {
    var total = 0;
    CCF('.CCF_input').each(function(){
      total += get_extra_for(CCF(this));
    });
    return total;
  }

  function render_total(total_extra_cost) {
    var last_price = (Number(cart_total)) / 100 + total_extra_cost;
    var price_last = store_currency.replace("{{amount}}", last_price.toFixed(2));
    CCF(total_price_selector).html(price_last);
  }

  // Initial state (e.g. Residence pre-selected or checkbox pre-checked)
  var initial_extra = calc_total_extra();
  if (initial_extra > 0) {
    render_total(initial_extra);
  }

  // Any change (checkbox OR dropdown) re-renders the total
  CCF('.CCF_input').on('change', function() {
    render_total(calc_total_extra());
  });

  var CCF_CHECKOUT_SELECTORS = ".CCF_checkout_btn, #checkout, .samitaWS-clone-checkout-button, .samitaWS-original-checkout-button, #dvPaypal, #dvAmazon, input[name='checkout'], button[name='checkout'], [href$='checkout'], input[name='goto_pp'], button[name='goto_pp'], input[name='goto_gc'], button[name='goto_gc'], .additional-checkout-button, .google-wallet-button-holder, .amazon-payments-pay-button";

  var ccf_checkout_in_progress = false;

  // Capture-phase listener: runs BEFORE the theme's / other apps' click
  // handlers (including the samitaWS clone button's own handler), so we
  // can save attributes / create the draft order first.
  document.addEventListener('click', function(ev){
    var btn = ev.target.closest(CCF_CHECKOUT_SELECTORS);
    if (!btn) return;

    ev.preventDefault();
    ev.stopPropagation();

    if (ccf_checkout_in_progress) return;
    ccf_checkout_in_progress = true;

    ccf_handle_checkout(ev);
  }, true);

  function ccf_handle_checkout(ev){

    if (CCF("[name='note']").length) {
      var note = CCF("[name='note']")[0].value;
    }
    if (CCF("[name='cart[note]").length) {
      var note = CCF("[name='cart[note]")[0].value;
    }

    var validate_pass = true;
    var attributes_arr = {};
    var add_cost_arr = [];

    CCF('.CCF_input').not( ":radio" ).each(function(){

      var $this = CCF(this);
      var attr_val = $this.val();
      var attr_key = $this.attr("name").match(/\[(.*?)\]/);
      var key = attr_key[1];

      $this.css('outline', 'none');

      // check if field is required
      var is_required = $this.data("required");

      // ---- surcharge collection ----
      if ($this.is(':checkbox') && $this.is(':checked')) {
        var cb_cost = Number($this.data("additional")) || 0;
        var cb_type = $this.data("additional-type") || "fixed";
        if (cb_cost > 0) {
          if (cb_type == "fixed") {
            add_cost_arr.push({ cost: cb_cost, field: key });
          } else {
            var ct = (Number(cart_total)) / 100;
            add_cost_arr.push({ cost: (ct / 100) * cb_cost, field: key });
          }
        }
      }

    if ($this.is('select')) {

  var $opt = $this.find('option:selected');

  var sel_cost = Number($opt.data("additional")) || 0;
  var sel_type = $opt.data("additional-type") || $this.data("additional-type") || "fixed";

  // Residence dropdown surcharge
  if (
      $this.attr('name') === 'attributes[Shipping to a Business or Residence?]' &&
      $this.val() === 'Residence'
  ) {
      sel_cost = 6;
      sel_type = "fixed";
  }

  if (sel_cost > 0) {
      if (sel_type == "fixed") {
          add_cost_arr.push({
              cost: sel_cost,
              field: key + " - " + attr_val
          });
      } else {
          var ct2 = Number(cart_total) / 100;
          add_cost_arr.push({
              cost: (ct2 / 100) * sel_cost,
              field: key + " - " + attr_val
          });
      }
  }
}
      // ---- end surcharge collection ----

      if(is_required && attr_val == ""){
        var msg = key + " field is required"
        validate_pass = false;
        return validate(this, msg);
      }

      if ($this.is(':checkbox')) {
        if ($this.is(':checked')) {
          attr_val = "yes";
        }else{
          attr_val = "no";
          if(is_required){
            var msg = key + " field is required"
            validate_pass = false;
            return validate(this, msg);
          }
        }
      }

      attributes_arr[key] = attr_val;
    });

    CCF('.CCF_radio_input').each(function(){

      // check if field is required
      var is_required = CCF(this).data("required");
      CCF(this).css('outline', 'none');

      var attr_key = CCF(this).find(".CCF_input").attr("name").match(/\[(.*?)\]/);
      var key = attr_key[1];

      if(CCF(this).find(".CCF_input").is(':checked')){
        var attr_val = CCF(this).find(".CCF_input:checked").val();
        attributes_arr[key] = attr_val;
      }else if(is_required){
        var msg = key + " field is required"
        validate_pass = false;
        return validate(this, msg);
      }

    });

    if(!validate_pass){
      ccf_checkout_in_progress = false;
      return false;
    }

    console.log(attributes_arr);

    var attributes = {
      'attributes':attributes_arr,
      'note': note
    };

    var request = CCF.ajax({
      url: "/cart/update.js",
      method: "POST",
      contentType: 'application/json',
      data: JSON.stringify(attributes),
      dataType: "json",
    });

    request.done(function( cart ) {

      if(add_cost_arr.length > 0){
        // create draft order
        create_draft_order(add_cost_arr, cart);
      }else{
        console.log("Normal");
        window.location = "/checkout";
      }

      return false;

    });

    request.fail(function() {
      // If saving attributes fails, don't strand the customer
      ccf_checkout_in_progress = false;
      window.location = "/checkout";
    });
  }
}

function  create_draft_order(add_cost_arr, cart) {

  var add_cost_data = JSON.stringify(add_cost_arr);
  var cart = JSON.stringify(cart);

  var request = CCF.ajax({
      url: "/apps/CCF",
      method: "POST",
      data: {action: "create_draft_order", add_cost_data: add_cost_data, cart: cart},
      dataType: "json",
      crossDomain: true
    });

  request.done(function( data ) {
    console.log(data);

    if(data.success){
      window.location = data.success.invoice_url;
    }else{

    }

  })

}